<template>
  <input type="text" :value="value" :placeholder="placeholder" />
</template>

<script>
  export default {
    name: 'input-field',
    props: ['placeholder', 'value']
  }
</script>



// WEBPACK FOOTER //
// src/components/common/InputField.vue